/*!
 * @Author: luoob
 * @Date: 2021-04-19 18:31:00
 * @Last Modified by: luoob
 * @Last Modified time: 2021-01-19 18:31:00
 * @Instruduction: 人物舆情接口
 */

import { BaseParams } from './index'
import xhr from './xhr/index'

interface IGetPersonParams {
    query?: string,                   // 搜索企业名/简称/上市代码
    page_index?: number,              // 第几页(默认1)
    page_size?: number                // 每页条数(默认20)
    person_type?: number              // 人物类型
}

interface IGetPersonDetailParams {
    id: number                        // 人物 id
}

interface IUpdatePersonInfoParams {
    id: number,                       // 编号
    name?: string,                    // 名字
    avatar?: string,                  // 头像
    honor?: string,                   // 头衔
    type_id?: number,                 // 领域 id
    nationality?: string,             // 国籍
    university?: string,              // 毕业院校
    birthday?: string,                // 生日
    link?: [string],                  // 自平台链接
    post?: [string],                  // 职务
    intro?: string,                   // 介绍
    keywords?: [string],              // A类关键词
    b_keywords?: [string],            // B类关键词
    check?: number
}

interface IGetkeywordFromUserParams {
    status?: number,                // 审核状态 0:待审核 1:通过 2:不通过
    page_index?: number,
    page_size?: number
}

interface IUpdatekeywordStatusParams {
    id: number,                    // 提交记录 id
    status: number                 // 审核状态
}

interface IPersonSettleListParams {
    status?: number,               // 状态 0:审核中 1:通过 2:不通过
    page_index?: number,           // 第几页
    page_size?: number             // 每页条数
}

interface IPersonSettleDetailParams {
    id: number
}

interface IUpdateSettleStatusParams {
    id: number,
    status: number
}

interface IPersonAuthListParams extends IPersonSettleListParams {}

interface IPersonAuthDetailParams extends IPersonSettleDetailParams {}

interface IUpdateAuthStatusParams extends IUpdateSettleStatusParams {}

interface IPrCertListParams {
    status?: number,               // 状态 0:审核中 1:通过 2:不通过
    page_index?: number,           // 第几页
    page_size?: number             // 每页条数
}

interface IPrCertDetailParams {
    id: number
}

interface IUpdatePrCertStatusParams {
    id: number,
    status: number
}

interface IEditInfoListParams extends BaseParams {
    status?: number
}

interface IGetEditInfoDetailParams {
    id: number
}

interface IUpdateEditInfoStatusParams {
    id: number
    status: number
}

interface IGetInterviewsParams {
    status?: number,               // 状态 0:待回复 1:已同意 2:已拒绝
    page_index?: number,           // 第几页
    page_size?: number             // 每页条数
}

interface IGetInterviewParams {
    id: number
}

class PersonService {
    /** 获取人物列表 */
    public async getPersonList(params: IGetPersonParams) {
        const result = await xhr({
            method: 'get',
            url: '/person/list',
            params: params
        })
        return result
    }

    /** 获取人物详情 */
    public async getPersonDetail(params: IGetPersonDetailParams) {
        const result = await xhr({
            method: 'get',
            url: '/person',
            params: params
        })
        return result
    }

    /** 更新人物信息 */
    public async updatePersonInfo(params: IUpdatePersonInfoParams) {
        const result = await xhr({
            method: 'put',
            url: '/person',
            params: params
        })
        return result
    }

    /** 获取用户提交的人物标签列表 */
    public async getKeywordFromUser(params: IGetkeywordFromUserParams) {
        const result = await xhr({
            method: 'get',
            url: '/person/keywords/list',
            params: params
        })
        return result
    }

    /** 人物标签审核 */
    public async updateKeywordStatus(params: IUpdatekeywordStatusParams) {
        const result = await xhr({
            method: 'put',
            url: '/person/keywords',
            params: params
        })
        return result
    }

    /** 获取人物入驻申请列表 */
    public async getPersonSettleList(params: IPersonSettleListParams) {
        const result = await xhr({
            method: 'get',
            url: '/person/join/list',
            params: params
        })
        return result
    }

    /** 获取人物入驻申请详情 */
    public async getPersonSettleDetail(params: IPersonSettleDetailParams) {
        const result = await xhr({
            method: 'get',
            url: '/person/join',
            params: params
        })
        return result
    }

    /** 更新人物入驻申请状态 */
    public async updatePersonSettleStatus(params: IUpdateSettleStatusParams) {
        const result = await xhr({
            method: 'put',
            url: '/person/join',
            params: params
        })
        return result
    }

    /** 获取人物认证申请列表 */
    public async getPersonAuthList(params: IPersonAuthListParams) {
        const result = await xhr({
            method: 'get',
            url: '/person/cert/list',
            params: params
        })
        return result
    }

    /** 获取人物认证申请详情 */
    public async getPersonAuthDetail(params: IPersonAuthDetailParams) {
        const result = await xhr({
            method: 'get',
            url: '/person/cert',
            params: params
        })
        return result
    }

    /** 更新企业入驻申请状态 */
    public async updatePersonAuthStatus(params: IUpdateAuthStatusParams) {
        const result = await xhr({
            method: 'put',
            url: '/person/cert',
            params: params
        })
        return result
    }

    /** 获取人物信息修改申请列表 */
    public async getEditInfoList(params: IEditInfoListParams) {
        const result = await xhr({
            method: 'get',
            url: '/person/update_apply/list',
            params: params
        })
        return result
    }

    /** 人物信息修改申请详情 */
    public async getEditInfoDetail(params: IGetEditInfoDetailParams) {
        const result = await xhr({
            method: 'get',
            url: '/person/update_apply',
            params: params
        })
        return result
    }

    /** 人物信息修改申请审核 */
    public async updateEditInfoStatus(params: IUpdateEditInfoStatusParams) {
        const result = await xhr({
            method: 'put',
            url: '/person/update_apply',
            params: params
        })
        return result
    }

    /** 获取采访列表 */
    public async getInterviews(params: IGetInterviewsParams) {
        const result = await xhr({
            method: 'get',
            url: '/person/interview/list',
            params: params
        })
        return result
    }

    /** 获取采访详情 */
    public async getInterview(params: IGetInterviewParams) {
        const result = await xhr({
            method: 'get',
            url: '/person/interview',
            params: params
        })
        return result
    }

    /** 创建人物 */
    public async createPerson(params: any) {
        const result = await xhr({
            method: 'post',
            url: '/person',
            params: params
        })
        return result
    }
}

// 实例化后导出，全局单例
export default new PersonService()
